import { LOAD_PRODUCTCATEGORIES, UNLOAD_PRODUCTCATEGORIES, UPDATE_PRODUCTCATEGORIES } from '../Reducers/ProductCategories';
import EndpointService from '../Service/EndpointService';
import moment from 'moment';


export function loadProductCategories(params) {
    return (dispatch) => {

        dispatch({
            type: LOAD_PRODUCTCATEGORIES,
            loading: true
        })
        return EndpointService.get("/freelancerportal/api/productcategories").then((response) => {
            
            dispatch({
                type: LOAD_PRODUCTCATEGORIES,
                loading: false,
                collection: response.data,
                lastSynced: Number(moment().subtract(5, 'm').format('x'))
            })
            

        }).catch(() => {

        })


    }
}

export function getProductCategories(params, reload) {
    return dispatch => {
        // syncing logic
        dispatch(loadProductCategories(params));
    }
}

